// src/pages/StudyChatPage.tsx
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import StudyChatBody from '@/modules/study-chat/StudyChatBody';

export default function StudyChatPage() {
  const { subjectId: subjectIdParam } = useParams();
  const [sp] = useSearchParams();
  const navigate = useNavigate();

  // Resolve subjectId from route (:subjectId) or query (?subjectId=)
  const q = subjectIdParam ?? sp.get('subjectId') ?? undefined;
  const subjectId = q != null && !Number.isNaN(Number(q)) ? Number(q) : undefined;

  // Read human-friendly title from ?title=
  const subjectTitle = (() => {
    const t = sp.get('title');
    return t ? t.trim() : '';
  })();

  // Final display label used in the page header
  const subjectLabel =
    subjectTitle || (subjectId ? `Subject #${subjectId}` : 'All subjects');

  return (
    <div className="page-shell min-h-screen flex flex-col">
      {/* content wrapper should be able to shrink so inner panels can scroll */}
      <div className="container-narrow flex-1 min-h-0 space-y-3">
        <header className="glass sticky top-0 z-40 px-3 py-2 flex items-center gap-2 backdrop-blur supports-[backdrop-filter]:bg-black/30">
          <Button variant="outline" onClick={() => navigate(-1)}>← Back</Button>

          {/* Middle: Study Groups · <subject> (ellipsized) */}
          <div className="min-w-0 text-sm text-white/80">
            <span className="opacity-80">Study Groups · </span>
            <span
              className="truncate align-middle max-w-[55vw] md:max-w-[36rem] inline-block"
              title={subjectLabel}
            >
              {subjectLabel}
            </span>
          </div>

          {/* Right spacer */}
          <div className="ml-auto" />
        </header>

        {/* main must be flex-1 + min-h-0 to let StudyChatBody own the scrolling */}
        <main className="glass p-4 flex-1 min-h-0">
          <StudyChatBody
            subjectId={subjectId}
            maxGroups={5}
            subjectName={subjectTitle} // pass title so the inner header uses the real name
          />
        </main>
      </div>
    </div>
  );
}
